export enum ResponsiveBreakpointType {
  Mobile = "Mobile",
  Tablet = "Tablet",
  Desktop = "Desktop",
}

export const ResponsiveBreakpoint = {
  [ResponsiveBreakpointType.Mobile]: 705,
  [ResponsiveBreakpointType.Tablet]: 1025,
};
